module.exports = "/packs/images/better-pdf-logo~86ed60e46368bd6fbfec1b8822a0a672.png";